import { lazy, Suspense } from "react";
import Page from "@jumbo/shared/Page";
import AccessMiddleware from "./middleware/auth/AccessMiddleware";
import {
  PACKING_ADD_ROUTE_FINISHED,
  PACKING_ADD_ROUTE_RAW,
  PACKING_APPROVAL_VIEW_DETAILS_ROUTE,
  PACKING_EDIT_FINISHED_ROUTE,
  PACKING_EDIT_RAW_ROUTE,
  PACKING_ROUTE,
} from "app/utils/constants/routeConstant";
import { LoadablePage } from "app/utils/loadablePage";
import { element } from "prop-types";

// Lazy import
const Packing = lazy(() => import("app/pages/Packing"));
const CreateRawPacking = lazy(() =>
  import("app/pages/Packing/RawReadyForPacking/createPacking")
);
const CreateFinishedPacking = lazy(() =>
  import("app/pages/Packing/FinishedReadyForPacking/createPacking")
);
const EditFinishedPackingDone = lazy(() =>
  import(
    "app/pages/Packing/packingDone/EditPacking/FinishedEdit/finishedEditIndex"
  )
);
const EditRawPackingDone = lazy(() =>
  import("app/pages/Packing/packingDone/EditPacking/RawEdit/rawEditIndex")
);
const PackingApprovalViewDetails = lazy(() =>
  import("app/pages/Packing/packingApproval/ViewDetails/ViewDetails")
);

export const packingModuleRoute = [
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "packing_permission", "view"],
      },
    ],
    routes: [
      {
        path: PACKING_ROUTE,
        element: LoadablePage(Packing),
      },
      { path: PACKING_ADD_ROUTE_RAW, element: LoadablePage(CreateRawPacking) },
      {
        path: PACKING_ADD_ROUTE_FINISHED,
        element: LoadablePage(CreateFinishedPacking),
      },
      {
        path: PACKING_EDIT_FINISHED_ROUTE,
        element: LoadablePage(EditFinishedPackingDone),
      },
      {
        path: PACKING_EDIT_RAW_ROUTE,
        element: LoadablePage(EditRawPackingDone),
      },
      {
        path: PACKING_APPROVAL_VIEW_DETAILS_ROUTE,
        element: LoadablePage(PackingApprovalViewDetails),
      },
    ],
  },
];
